
export default {
    name: "addCustomer",
    conditionData : "",
    data() {
        return {
            companyForm: {
                companyName: '',
            }
        }
    },
    mounted: function () {
    },
    created() {
        this.conditionData = this.$routerUtil.getParam();
    },
    computed: {
        rules() {
            return {
                companyName: [
                    {required: true, message: this.$t('customerManage.message.companyName'), trigger: 'blur'},
                    {max: 50, message: this.$t('customerManage.message.tooLong') + 50, trigger: 'blur'}
                ]
            }
        },
    },
    methods: {
        submitForm(formName) {
            console.log(this.$refs[formName], this.$refs);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const param = {};
                    param.companyName = this.companyForm.companyName;
                    param.companyNameEn = this.companyForm.companyName;
                    console.log(param);
                    this.$axios.post('/api/customerCompay/insertCustomerInvite', param).then(response => {
                        let type = 'error';
                        if (response.data.status === '1') {
                            type = 'success';
                            this.back();
                        }
                        this.$message({
                            message: this.$t(response.data.message),
                            type: type,
                            center: true
                        });
                    }).catch(e => {
                        console.log(e);
                        this.$message({
                            message: this.$t('common.message.operateFail'),
                            type: 'error',
                            center: true
                        });
                    })
                }
            });
        },
        back() {
            this.$routerUtil.setParam(this.conditionData.searchForm);
            this.$router.back();
        }
    }
}
